module.exports = __webpack_public_path__ + "media/images/wttest2-24b8b70dc27c403478f16ce5856520b8.png";